<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Programación de factura</h3>
            </div>
        </div>
        <div class="card">
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12">
                        <p>
                            <label for="primerDia">
                                <input v-model="form.tipo_programacion" type="radio" id="primerDia" value="P"> <span>Primer día del mes</span>
                            </label>
                        </p>
                        <p>
                            <label for="quincena">
                                <input v-model="form.tipo_programacion" type="radio" id="quincena" value="Q"> <span>Quincena</span>
                            </label>
                        </p>
                        <p>
                            <label for="ultimoDia">
                                <input v-model="form.tipo_programacion" type="radio" id="ultimoDia" value="F"> <span>Último día del mes</span>
                            </label>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-buttons">
            <button @click="aceptar" class="btn-success" type="button"><i class="fa fa-save"></i><span>Aceptar</span></button>
            <button @click="cancelar" class="btn-danger btn--text"><i class="fa fa-ban"></i><span>Cancelar</span></button>
        </div>
    </div>
</template>


<script>
export default {
    props : {
        idComprobante : {
            type : String,
            required : true
        }
    },
    data : function () {
        return {
            url : url,
            form : {
                tipo_programacion : 'P'
            }
        };
    },
    methods : {
        cancelar : function () {
            this.$emit('cancelar');
        },
        aceptar : function () {
            let that = this;
            axios.post(this.url + '/comprobantes/' + this.idComprobante + '/programar', this.form).then(function (response) {
                swal('La factura fue programada exitósamente.', 'Realizado', 'success');
                that.$emit('accepted');
            }).catch(function (error) {
                swal('Hubo un error, intente nuevamente.', 'Aviso', 'warning');
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/ProgramacionFactura.vue